import React, {useCallback} from 'react';
import {showHelp} from '../../../common/helpPopover';
import {DIALOG_ID} from '../constants';
import {listTypes} from '../enum';
import texts from '../../../../../components/Common/SelectListModal/text';

type Props = {
    onDialogClose: () => void;
    type: listTypes;
};

export const useDialogContent = (props: Props) => {
    const {onDialogClose, type} = props;
    const [selectedValue, setSelectedValue] = React.useState<string>('');

    const currentItemRef = React.useRef(null);
    const focusedIndex = React.useRef(0);
    const listRef = React.useRef<HTMLDivElement>(null);

    const onFocusChange = useCallback((item, index) => {
        currentItemRef.current = item;
        focusedIndex.current = index;
    }, []);

    const handleShowHelpMessage = useCallback(async () => {
        const item = currentItemRef.current;
        if (item && typeof focusedIndex.current === 'number') {
            const anchor =
                listRef.current.querySelectorAll<HTMLElement>('.pui-dropdown-item ')[
                    focusedIndex.current
                ];

            if (!anchor) return;

            const data =
                listTypes.FormSons === type ? {Fname: item.value} : {Exec: Number(item.value)};

            await showHelp({
                ...data,
                anchor,
                portalSelector: DIALOG_ID,
                strategy: 'fixed'
            });
        }
    }, []);

    const onItemClick = useCallback(({value}) => {
        setSelectedValue(value);
    }, []);

    const onAccept = useCallback(() => {
        currentItemRef.current.data?.action?.();
        onDialogClose();
    }, [onDialogClose]);

    const getNoOptionsText = useCallback(() => {
        if (type === listTypes.DirectActivations || type === listTypes.DirectActivationsF) {
            return texts.DirectActivationsNoResults;
        }
        return texts.FormSonsNoResults;
    }, []);

    return {
        selectedValue,
        listRef,
        onFocusChange,
        handleShowHelpMessage,
        onItemClick,
        onAccept,
        getNoOptionsText
    };
};
